import { config } from "config";
import { keycloakInstance } from "keycloak";

export type ExtendedRequestInit = RequestInit & {
  baseUrl?: string,
  extractResult?: boolean
}

export const fetchWithToken = async (input: RequestInfo, init?: ExtendedRequestInit) => {
  try {
    return await fetch(input, {
      ...init,
      headers: {
        ...init?.headers,
        authorization: `Bearer ${await keycloakInstance.getKeycloakToken()}`,
      },
    });
  } catch (e) {
    throw e ?? new Error("Unknown fetch error");
  }
};

export const apiCallWithoutToken = async <T = any>(path: string, body?: any, init?: ExtendedRequestInit): Promise<T> => {
  const url = init?.baseUrl || `${config.host}:${config.port}`;

  const result = await fetch(`${url}${path}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(body),
    ...init,
  });

  if (init?.extractResult === false) {
    return result as any as T;
  }
  return result.json();
};

